import { ModelSagres } from "../model-sagres"
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";

export class Prorrogacoes extends ModelSagres {
    IdProrrogacao: number
    BuscaGeral: string
    UnidadeGestora?: UnidadeGestoraResumida | string
    IdUnidadeGestora: number
    Exercicio: number
    Mes: number
    MesRef: number
    DataVencimento: Date
    NrProtocoloAutorizacao: string
    TipoRelatorio: string
    TipoProrrogacao: string
    IdTipoRelatorio: number
    IdPeriodoRelatorio: number
    Periodo: number
    /**
     * Trata os dados recebidos pela API. Estão vindo com estas três inconsistências no momento. Não execute em outras situações
     * @since 20220613
     */
    tratarDadosDaAPI(): void {
        if (typeof (this as any).Ref !== 'undefined') {
            this.MesRef = (this as any).Ref
        }
        if (this.DataVencimento) {
            this.DataVencimento = new Date(this.DataVencimento)
        }
    }

    toFormData(): FormData {
        const data = new FormData()
        for (const key in this) {
            //console.log(key, this[key])
            if(key == 'IdProrrogacao' && this.IdProrrogacao != null){
                data.append('idProrrogacao', String(this[key]))
            }
            if(key == 'Exercicio'){
                data.append('exercicio', String(this[key]))
            }
            else if(key == 'TipoProrrogacao'){
                if(this.TipoProrrogacao == 'LRF' && this.IdTipoRelatorio)
                    data.append('tipoRelatorioLRF', String(this.IdTipoRelatorio))
                if(this.TipoProrrogacao == 'LRF' && this.IdTipoRelatorio)
                    data.append('periodoRelatorioLRF', String(this.IdPeriodoRelatorio))                    
                data.append('tipoProrrogacao', String(this[key]))
            }
            else if(key == 'DataVencimento'){
                data.append('dtVencimento', (this[key] as unknown as Date).toISOString())
            }
            else if(key == 'UnidadeGestora' && this.UnidadeGestora){
                data.append('idUgPCM', String((this.UnidadeGestora as UnidadeGestoraResumida).IdPCM))
            }
            else if(key == 'MesRef' && this['TipoProrrogacao'] != 'LRF'){
                data.append('referencia', String(this[key]))
            }
            else if(key == 'NrProtocoloAutorizacao'){
                data.append('nrProtAutorizacao', String(this[key]))
            }                                
        }
        /* console.table([...data]) */
        return data
    }
}